/* eslint-disable react-native/no-inline-styles */
import { format } from 'date-fns';
import { Notification, NotificationStatusId } from '@packages/models/api';
import { TouchableOpacity, View, StyleSheet } from 'react-native';
import { Typography } from '../typography';
import { UnreadStatusIndicator } from '../unread-status-indicator';
import colors from '@packages/core/styles/colors';
import React, { FC, useMemo } from 'react';
import { Icon } from '../icon';

interface NotificationProps {
    item: Notification;
    fluid?: boolean;
    onPress(notification: Notification): void;
}

export const ListItemNotification: FC<NotificationProps> = ({ item, fluid, onPress }) => {
    function handleNotificationPress() {
        onPress(item);
    }

    const isNew =
        item.notificationStatusId === NotificationStatusId.New ||
        item.notificationStatusId === NotificationStatusId.Unread;

    const formattedTimestamp = useMemo(() => {
        const timestampDate = new Date(item.createdTimestamp);
        const formatString = 'EEE dd, yyyy - HH:mm:ss';
        return format(timestampDate, formatString);
    }, [item.createdTimestamp, item.notificationGroupingId]);

    return (
        <TouchableOpacity
            style={[
                styles.notificationListItem,
                {
                    paddingHorizontal: fluid ? 0 : 24,
                    backgroundColor: isNew ? colors.white : colors.grayOne,
                },
            ]}
            onPress={handleNotificationPress}
        >
            <View style={styles.notificationMessageOuter}>
                <View style={styles.messageContainer}>
                    <Typography
                        variant={isNew ? 'label' : 'labelRegular'}
                        style={styles.notificationMessage}
                        color="blueOne"
                    >
                        {item.message} {isNew && <UnreadStatusIndicator />}
                    </Typography>
                    <Typography variant="caption" color="textDarkSecondary" style={styles.timestamp}>
                        {formattedTimestamp}
                    </Typography>
                </View>
                <View style={styles.arrowContainer}>
                    <Icon name="chevron-right" />
                </View>
            </View>
        </TouchableOpacity>
    );
};

const styles = StyleSheet.create({
    notificationListItem: {
        paddingVertical: 8,
    },
    notificationMessageOuter: {
        marginBottom: 8,
        flexDirection: 'row',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    messageContainer: {
        display: 'flex',
        width: 326,
    },
    notificationMessage: {
        flex: 1,
        fontSize: 15,
        fontWeight: '400',
        color: colors.blueOne,
    },
    timestamp: {
        fontSize: 13,
        fontWeight: '400',
    },
    arrowContainer: {
        flexShrink: 0,
        paddingLeft: 16,
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
    },
    notificationVehicleText: {
        marginBottom: 8,
    },
});
